// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Link from "next/link";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_int32 from "../../../../../node_modules/rescript/lib/es6/caml_int32.js";
import * as NextImage$PorterinFeature from "./NextImage.mjs";
import * as CityContext$PorterinFeature from "../../contexts/city-context/CityContext.mjs";
import * as GAEventsConstants$PorterinFeature from "../../shared/core/constants/GAEventsConstants.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../shared/core/helpers/PublishEventsHelper.mjs";
import * as ServicesCardModuleScss from "../styles/common/ServicesCard.module.scss";

var styles = ServicesCardModuleScss;

function ServicesCardCmp(Props) {
  var content = Props.content;
  var index = Props.index;
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var getGradient = function (param) {
    var gradients = [
      "gradient-red-to-purple",
      "gradient-green-to-blue",
      "gradient-blue-to-red",
      "gradient-cyan-to-blue"
    ];
    return Belt_Array.getExn(gradients, Caml_int32.mod_(index, gradients.length));
  };
  return React.createElement(Link, {
              href: content.link + citySelectedContext.query_params,
              children: React.createElement("div", {
                    className: "" + styles["services-card"] + " " + getGradient(undefined) + "\n        }",
                    onClick: (function (param) {
                        PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, GAEventsConstants$PorterinFeature.gaServiceCardAction + content.sub_text, content.link);
                      })
                  }, React.createElement("div", {
                        className: styles["subtext-holder"]
                      }, React.createElement("div", {
                            className: styles.subtext
                          }, content.sub_text)), React.createElement("div", {
                        className: styles["text-holder"]
                      }, React.createElement("div", {
                            className: styles.text
                          }, content.text)), React.createElement("div", {
                        className: styles["icon-bg"]
                      }, React.createElement(NextImage$PorterinFeature.make, {
                            src: content.image.path,
                            height: 20.0,
                            width: 20.0,
                            quality: 100.0,
                            alt: "Right Arrow Icon"
                          })))
            });
}

var Link$1;

var make = ServicesCardCmp;

export {
  Link$1 as Link,
  styles ,
  make ,
}
/* styles Not a pure module */
